import { useQuery } from 'react-query';
import { fetchFAQ } from '../apiCalls';
import { QueryKey } from './QueryKeys';

const useFAQ = (apiEnv, product) => {
	const { data } = useQuery([QueryKey.GET_FAQS, apiEnv, product], fetchFAQ);

	return {
		data,
	};
};

export default useFAQ;
